var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.208 12.1944C20.208 11.5881 20.1536 11.0052 20.0525 10.4456H12V13.7529H16.6015C16.4032 14.8216 15.8009 15.7271 14.8953 16.3334V18.4787H17.6585C19.2753 16.9902 20.208 14.7983 20.208 12.1944Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20.55C14.3085 20.55 16.2439 19.7844 17.6585 18.4786L14.8953 16.3333C14.1297 16.8463 13.1503 17.1494 12 17.1494C9.77308 17.1494 7.88819 15.6454 7.21585 13.6245H4.35938V15.8397C5.76624 18.634 8.65769 20.55 12 20.55Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.21511 13.6246C7.04411 13.1116 6.94695 12.5637 6.94695 12.0001C6.94695 11.4366 7.04411 10.8886 7.21511 10.3756V8.1604H4.35863C3.77956 9.31465 3.44922 10.6205 3.44922 12.0001C3.44922 13.3798 3.77956 14.6856 4.35863 15.8399L7.21511 13.6246Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6.85076C13.2553 6.85076 14.3823 7.28215 15.2684 8.12938L17.7207 5.67708C16.24 4.29742 14.3046 3.4502 12 3.4502C8.65769 3.4502 5.76624 5.36617 4.35938 8.16047L7.21585 10.3757C7.88819 8.35479 9.77308 6.85076 12 6.85076Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.54d27ff13fc72ee29ac25a2bf9be78b7.svg";
export { ForwardRef as ReactComponent };